module.exports = __webpack_public_path__ + "static/battle03-f3a4797c58f787b80fd8303a57251ccd.png";